import { NextRouter } from "next/router";

import { getIsSavedAssignment } from "@/assignments/utils/assignmentUrlHelpers";
import { type Assignment } from "@/types/models/Assignment.interface";

interface UpdateUrlAfterSave {
  response: {
    data: Assignment;
  };
  router: NextRouter;
  selectedAssignment: {
    assignment_id: Assignment["assignment_id"];
  };
}

export const updateUrlAfterSave = ({
  response,
  router,
  selectedAssignment,
}: UpdateUrlAfterSave) => {
  const { query, pathname } = router;
  const isSavedAssignment = getIsSavedAssignment(
    selectedAssignment?.assignment_id,
  );

  if (isSavedAssignment) return;

  // We're removing selectedAssignmentId from the url on save
  const { selectedAssignmentId, ...paramsWithoutSelectedAssignmentId } = query;
  const {
    data: { content_id: contentId },
  } = response;

  const href = {
    pathname,
    query: {
      ...paramsWithoutSelectedAssignmentId,
      selectedAssignmentId: contentId,
    },
  };

  void router?.replace(href as unknown as URL, undefined, { shallow: true });
};

export default updateUrlAfterSave;
